import React from 'react';
import { TableProps } from 'tea-component';
import BaseMetricsTable, { IBaseMetricsTableCommonProps } from '../BaseTable';
import { getProjectMetricsColumns } from '../../utils/columns';

import type { IBaseProps } from '@home/types/common';
import type { IMetricsProjectMetric } from '@gp/types/metrics';

interface IProjectMetricsTableProps
  extends IBaseProps,
  Omit<TableProps, 'verticalTop' | 'addons' | 'columns' | 'recordKey' | 'records'>,
  IBaseMetricsTableCommonProps<IMetricsProjectMetric> {
  keyword?: string;
}

const ProjectMetricsTable: React.FC<IProjectMetricsTableProps> = (props) => {
  const { keyword, ...restProps } = props;

  const columns = getProjectMetricsColumns({ keyword });

  return (
    <BaseMetricsTable
      {...restProps}
      sortableKeys={['metric', 'data_source', 'update_frequency', 'owner']}
      columns={columns}
    />
  );
};

export default ProjectMetricsTable;
